import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { ToCurrencyString } from 'services/formatService';

const RefreshTaxModal = ({ classes, isModalOpen, handleConfirmation, handleCancellation, canRefresh, requestedPriceParameter }) => {

  const getTextContent = () => {
      if(requestedPriceParameter == null){
        return `Can not refresh model tax with empty bid price.`
      }
      else if(requestedPriceParameter > 0){
        return `Do you want to refresh model tax with selected bid price ${ToCurrencyString(requestedPriceParameter)}?`
      }
      else{
        return `Can not refresh model tax with selected bid price ${ToCurrencyString(requestedPriceParameter)}.`
      }
  }

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
    handleCancellation();
  }

  return (
    <Dialog onClose={handleClose} open={isModalOpen} className={classes.dialog}>
      <DialogTitle>
        Refresh Model Tax
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={handleCancellation}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {getTextContent()}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancellation}>Cancel</Button>
        <Button onClick={handleConfirmation} variant="contained" color="primary" disabled={!canRefresh}>Yes</Button>
      </DialogActions>
    </Dialog>
  )
}

const styles = theme => ({
  dialog: {
    minWidth: '200px',
    minHeight: '150px'
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    // backgroundColor: '#ffffff'
  },
});



export default compose(
  withStyles(styles)
)(RefreshTaxModal);